import {Mapper} from '../../../../core/abstracts/mapper.abstract';
import {VehicleModelResponse} from '../model/vehicle-model-response.model';
import {VehicleModel} from '../model/vehicle-model.model';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class VehicleModelsResponseMapper extends Mapper<VehicleModelResponse, VehicleModel> {

  map(source: VehicleModelResponse): VehicleModel {
    return new VehicleModel(
      source.id,
      source.name);
  }
}
